// extracted by mini-css-extract-plugin
export default {"leftArrow":"CarousalLeftNav_leftArrow__hnQiU"};